import { render, staticRenderFns } from "./PointCollectedTopIcon.vue?vue&type=template&id=519e1ec0&scoped=true&lang=pug&"
import script from "./PointCollectedTopIcon.vue?vue&type=script&lang=js&"
export * from "./PointCollectedTopIcon.vue?vue&type=script&lang=js&"
import style0 from "./PointCollectedTopIcon.vue?vue&type=style&index=0&id=519e1ec0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519e1ec0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
